import Svg from '@material-symbols/svg-400/outlined/arrow_drop_down.svg'
import { type SvgIconProps } from '@mui/material'
import { MaterialSymbol } from './MaterialSymbol'

export function ArrowDropDownIcon(props: SvgIconProps) {
  return <MaterialSymbol icon={Svg} {...props} />
}
